'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _pipeWith = require('./util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

var _delete = require('./delete');

var _delete2 = _interopRequireDefault(_delete);

var _first = require('./first');

var _first2 = _interopRequireDefault(_first);

var _shift = require('./shift');

var _shift2 = _interopRequireDefault(_shift);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'rest',
    immutable: 'rest',
    object: function object() {
        return function (value) {
            return (0, _pipeWith2.default)(value, (0, _delete2.default)((0, _pipeWith2.default)(Object.keys(value), (0, _first2.default)())));
        };
    },
    array: _shift2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/rest.js
// module id = 905
// module chunks = 35783957827783